<template>
<section class="sc-o27kl3-0 gsZmuC product-slider-section mb-4 mx-3 rounded px-3 rounded " style="background: red;">
  <div class="py-3">
    <h3 class="text-light" style="font-size:1.2em;font-weight:600">تخفیف های ویژه</h3>
    <small class="text-light">تخفیف های امروز در راداَپ</small>
  </div>
  <div>
    <div class="sc-d8w7bo-1 jpdybm">
      <div direction="row" class="sc-1r3hge1-0 heMFVq scroll-example">
          <product-vue :list="props.items"></product-vue>
      </div>
      <router-link class="btn w-100" style="background-color: #eef1f9;" :to="{name:'DampBtn',params:{whole:'damp',storeId:'a0'}}">مشاهده همه</router-link>
    </div>
  </div>
</section>
  
</template>

<script setup>
import productVue from '@/components/section/item/product.vue';
import { defineProps } from 'vue';
let props = defineProps(['items'])
</script>


<style scoped>

</style>